import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { useGetHygieneProviderInsightsData } from '@/react-query/insights/useGetHygieneProviderInsightsData';

import { endDateAtom, startDateAtom } from '../../atoms';

export const useGetFilteredHygieneTasks = ({
  providerId,
  practiceId,
}: {
  providerId: number;
  practiceId?: number;
}) => {
  const startDate = useAtomValue(startDateAtom);
  const endDate = useAtomValue(endDateAtom);

  const { data, isLoading } = useGetHygieneProviderInsightsData({
    providerId: providerId,
    start: startDate,
    end: endDate,
    practiceId: practiceId,
  });

  const filteredData = useMemo(() => {
    return (
      // For now, filter out results where only perio chart is suggested/completed
      data?.filter(
        (task) => task.bitewings || task.perioMaintenance || task.prophy,
      ) ?? []
    );
  }, [data]);

  return { data: filteredData ?? [], isLoading };
};
